import { css } from '@emotion/core';
import { createHeading } from './headings';
import Paragraph from './Paragraph';
import Code from './Code';
import ThematicBreak from './ThematicBreak';
export const topLevelElementCss = css `
  position: relative;
  z-index: 0; /* "position: relative" and "z-index: 0" create a new stacking context, which is necessary to stack prefix components */
  margin: 0;
  margin-left: 30px;
  flex-grow: 1;
  min-width: 0; /* NOTE: Very important for word-break to work properly. See https://github.com/tuttieee/tasquet/issues/376 */
  /* https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/ */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
`;
export const Empty = Paragraph;
const HTML = Code;
export const getLeafBlockComponent = (mdastNode) => {
    switch (mdastNode.type) {
        case 'paragraph':
            return Paragraph;
        case 'code':
            return Code;
        case 'html':
            return HTML;
        case 'heading':
            return createHeading(mdastNode.depth);
        case 'thematicBreak':
            return ThematicBreak;
        // TODO: tableCell
        default:
            return Paragraph;
    }
};
//# sourceMappingURL=index.js.map